<template>
    <svg
        width="660"
        height="443"
        viewBox="0 0 660 443"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            x="287"
            y="58"
            font-family="Inter"
            font-weight="700"
            font-size="34"
            fill="var(--et-colors-text)"
        >
            FAQs
        </text>
        <text
            x="220"
            y="95"
            font-family="Inter"
            font-weight="500"
            font-size="15"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        >
            Can not find answer? Contact us
        </text>
        <path
            d="M373.367 99H451.128V99.8H373.367V99Z"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        />
        <g>
            <g clip-path="url(#clip0_414_3450)">
                <rect
                    width="596"
                    height="135.5"
                    transform="translate(32 129)"
                    fill="var(--et-colors-card-background)"
                />
                <text
                    x="56"
                    y="170"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    Will I receive a VAT invoice?
                </text>

                <path
                    d="M598 168L592 162L586 168"
                    stroke="var(--et-colors-card-text)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <rect
                    x="56"
                    y="188.786"
                    width="480"
                    height="12"
                    rx="6"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="56"
                    y="208.643"
                    width="420"
                    height="12"
                    rx="6"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="56"
                    y="228.5"
                    width="240"
                    height="12"
                    rx="6"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect x="32" y="264.5" width="596" height="1" fill="var(--et-colors-border)" />
                <rect
                    width="596"
                    height="72"
                    transform="translate(32 265.5)"
                    fill="var(--et-colors-card-background)"
                />
                <text
                    x="56"
                    y="307"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    Can I return the purchased product?
                </text>
                <path
                    d="M586 298.5L592 304.5L598 298.5"
                    stroke="#667085"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <rect x="32" y="337.5" width="596" height="1" fill="var(--et-colors-border)" />
                <rect
                    width="596"
                    height="72"
                    transform="translate(32 338.5)"
                    fill="var(--et-colors-card-background)"
                />
                <text
                    x="56"
                    y="379"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    How do I get the source file?
                </text>
                <path
                    d="M586 371.5L592 377.5L598 371.5"
                    stroke="var(--et-colors-border)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_414_3450">
                <rect x="32" y="129" width="596" height="281.5" rx="12" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
